import React from 'react';
import { Row } from 'react-bootstrap';
import { Selectize, Fieldset } from '~/components/FormControl';
import PropTypes from 'prop-types';
import { maxLimit } from '../BoonForm';

function BonusAndDamage({ posOptions }) {
    return (
        <Fieldset
            className={'px-4'}
            fieldsetStyle={{ flexGrow: 1 }}
        >
            <Fieldset.Legend>Bonus and Damage:</Fieldset.Legend>
            <Row>
                <Selectize
                    name="bonusHpmList"
                    sm={3}
                    options={posOptions}
                    maxLimit={maxLimit}
                />
                <Selectize
                    name="bonusHwatList"
                    sm={3}
                    options={posOptions}
                    maxLimit={maxLimit}
                />
                <Selectize
                    name="damageCapList"
                    sm={3}
                    options={posOptions}
                    maxLimit={maxLimit}
                />
            </Row>
        </Fieldset>
    );
}

BonusAndDamage.propTypes = {
    posOptions: PropTypes.array.isRequired,
};

export default BonusAndDamage;
